import {Proxy} from "../../../settings";
import {baseDeleteRequest} from "../base/baseDeleteRequest";

const deletePrePotentionalClient = async (id: number) =>
  baseDeleteRequest(
    `${Proxy}/pre_potentional_client/${id}/`
  );

export default deletePrePotentionalClient;
